import PropTypes from 'prop-types';
import React from 'react';

import { Color, colorList, ComponentSize, IconStatus } from '../../../typings/design-tokens';
import { IComponent } from '../../../typings/generic-component';
import styles from '../../../utils/styles';

import './icon.scss';

export const iconSizeList: ComponentSize[] = [
  // 'xxxsmall',
  // 'xxsmall',
  'xsmall',
  'small',
  'medium',
  'large',
  'xlarge',
  // 'xxlarge',
];

export const statusIconList: ['normal', 'hover', 'pressed', 'disabled'] = ['normal', 'hover', 'pressed', 'disabled'];

export type VerticalAlign = 'top' | 'middle' | 'bottom';
export const verticalAlignList: VerticalAlign[] = ['top', 'middle', 'bottom'];

export interface IIcon extends IComponent {
  status?: IconStatus;
  svg?: Function;
  reverse?: Boolean;
  verticalAlign?: VerticalAlign;
}

const sizes = Object.freeze({
  // xxxsmall: 8,
  // xxsmall: 14,
  xsmall: 20,
  small: 30,
  medium: 60,
  large: 80,
  xlarge: 100,
  // xxlarge: 150,
});

const Icon: React.FC<IIcon> = ({
  color = 'inherit',
  status = 'normal',
  size = 'xsmall',
  svg = () => {},
  reverse = false,
  verticalAlign,
}) => {
  const className = styles(
    `icon icon--c-${color} icon--${size}`,
    verticalAlign && `icon--align-${verticalAlign}`,
    reverse && 'icon--reverse'
  );
  return (
    <i className={className}>
      {svg({
        width: sizes[size],
        height: sizes[size],
        status,
      })}
    </i>
  );
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  Icon.propTypes = {
    color: PropTypes.oneOf<Color>(colorList),
    reverse: PropTypes.bool,
    size: PropTypes.oneOf(iconSizeList),
    svg: PropTypes.func,
    verticalAlign: PropTypes.oneOf(verticalAlignList),
  };
}

export default Icon;
